import { IconArrowLeft } from '@tabler/icons-react';
import cn from 'classnames';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import BaseClickable from '@/components/ui/BaseClickable';

import s from './ButtonBack.module.scss';

type Props = {
  title?: React.ReactNode;
  to?: string;
  goBack?: boolean;
  className?: string;
};

const ButtonBack: React.FC<Props> = ({ title, to, goBack, className }) => {
  const navigate = useNavigate();
  const handleClick = () => goBack && navigate(-1);

  const isLink = Boolean(to && !goBack);
  const element = isLink ? 'link' : 'button';
  const extraProps = isLink ? { to } : { onClick: handleClick };

  return (
    <BaseClickable withHover element={element} {...extraProps} className={cn(s.root, className)}>
      <IconArrowLeft size={24} />
      {title}
    </BaseClickable>
  );
};

export default React.memo(ButtonBack);
